<template>
  <div class="dialog-bind-url-wrapper">
    <el-dialog title="生成绑定二维码" :visible="visible" @close="onDialogClose">
      <el-form label-position="top" ref="bindUrlForm" :rules="bindUrlRules" :model="bindUrlForm">
        <el-form-item label="设备 IMEI 号(clientid)" prop="clientid">
          <el-input v-model="bindUrlForm.clientid"
            @keyup.enter.native="onBindUrlSubmit"></el-input>
        </el-form-item>
        <el-form-item label="物联卡号(iccid)" prop="iccid">
          <el-input v-model="bindUrlForm.iccid"
            @keyup.enter.native="onBindUrlSubmit"></el-input>
        </el-form-item>
        <el-form-item style="display: flex; justify-content: center;">
          <el-button type="danger" @click="onBindUrlSubmit">{{ qrcodeInfo.showing ? '重新生成' : '确定' }}</el-button>
          <el-button @click="onBindUrlCancel">取消</el-button>
        </el-form-item>
      </el-form>
      <div class="qrcode-wrapper">
        <div style="text-align: center; padding: 2rem 0;">
          <div id="qrcode" ref="qrcode"></div>
          <el-button
            style="margin-top: 1rem;"
            @click="downloadQrcode"
            v-if="qrcodeInfo.showing">二维码下载</el-button>
        </div>
        <div class="qrcode-info" v-if="qrcodeInfo.showing">
          <h3>设备号 (sn): </h3> {{ qrcodeInfo.sn || '未知' }} <br/>
          <h3>设备 IMEI 号 (clientid): </h3> {{ qrcodeInfo.clientid || '未知' }} <br/>
          <h3>物联卡号 (iccid): </h3> {{ qrcodeInfo.iccid || '未知' }} <br/>
          <h3>绑定链接: </h3> {{ qrcodeInfo.bindUrl || '未知' }} <br/>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2'

import { mapActions } from 'vuex'

export default {
  name: 'DialogBindUrl',
  props: {
    visible: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      // 获取绑定二维码链接
      qrcode: {},
      qrcodeInfo: {
        showing: false
      },
      bindUrlForm: {
        clientid: '',
        iccid: ''
      },
      bindUrlRules: {
        clientid: [
          { required: true, message: '请输入设备 IMEI 号', trigger: 'blur' }
        ],
        iccid: [
          { required: true, message: '请输入设备物联卡号', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    ...mapActions('device', [
      'bindUrl'
    ]),

    onDialogClose () {
      this.$emit('update:visible', false)
    },
    onBindUrlSubmit () {
      this.bindUrlForm.clientid = this.bindUrlForm.clientid.trim()
      this.$refs['bindUrlForm'].validate(valid => {
        if (valid) {
          this.bindUrl({
            clientid: this.bindUrlForm.clientid,
            iccid: this.bindUrlForm.iccid
          }).then(res => {
            this.qrcodeInfo.showing = true

            // New qrcode img
            if (JSON.stringify(this.qrcode) !== '{}') {
              this.qrcode.clear()
              this.qrcode.makeCode(res.data.url)
            } else {
              this.qrcode = new QRCode('qrcode', {
                width: 200,
                height: 200,
                text: res.data.url
              })
            }

            this.qrcodeInfo.sn = res.data.sn
            this.qrcodeInfo.clientid = res.data.clientid
            this.qrcodeInfo.iccid = res.data.iccid
            this.qrcodeInfo.bindUrl = res.data.url

            this.$emit('data-change')
          })
        } else {
          return false
        }
      })
    },
    onBindUrlCancel () {
      this.$emit('update:visible', false)
      this.$refs['bindUrlForm'].resetFields()
    },

    // 下载绑定二维码
    downloadQrcode () {
      if (!this.qrcodeInfo.showing) {
        return
      }
      const ele = document.getElementById('qrcode').firstElementChild
      const data = ele.toDataURL('image/png')
      const filename = `${this.qrcodeInfo.sn}绑定二维码.png`

      const saveLink = document.createElementNS('http://www.w3.org/1999/xhtml', 'a')
      saveLink.href = data
      saveLink.download = filename
      var event = document.createEvent('MouseEvents')
      event.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null)
      saveLink.dispatchEvent(event)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/sass/base";

.dialog-bind-url-wrapper {
  .qrcode-wrapper {
    display: flex;
    justify-content: space-around;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dev/DialogBindUrl.vue